import { AxiosResponse } from 'axios';
import request from '../request';
import { IService } from 'src/core/infrastructure';
import {
  WhatIfAgesResponse,
  WhatIfLangResponse,
  WhatIfStoriesRequest,
  WhatIfStoriesResponse,
  WhatIfStorySubmitRequest,
  WhatIfStorySubmitResponse,
  WhatIfStoryViewResponse,
  WhatIfTopic,
  WhatIfTopicsRequest,
} from './types';

export const getWhatIfAges = async (): Promise<WhatIfAgesResponse> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/get-whatif-ages',
    headers: header,
  };

  const response =
    await request.requestService<AxiosResponse<WhatIfAgesResponse>>(data);
  return response.data;
};

export const getWhatIfLanguages = async (): Promise<WhatIfLangResponse> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/get-whatif-langs',
    headers: header,
  };

  const response =
    await request.requestService<AxiosResponse<WhatIfLangResponse>>(data);
  return response.data;
};

export const getWhatIdTopics = async (
  dataBody: WhatIfTopicsRequest,
): Promise<WhatIfTopic> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService<WhatIfTopicsRequest> = {
    method: 'POST',
    relativePath: '/get-whatif-trainingtopics-on-child',
    headers: header,
    data: dataBody,
  };

  const response = await request.requestService<
    AxiosResponse<WhatIfTopic>,
    WhatIfTopicsRequest
  >(data);
  return response.data;
};

export const getWhatIfStory = async (
  dataBody: WhatIfStoriesRequest,
): Promise<WhatIfStoriesResponse> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService<WhatIfStoriesRequest> = {
    method: 'POST',
    relativePath: '/get-whatif-stories',
    headers: header,
    data: dataBody,
  };

  const response = await request.requestService<
    AxiosResponse<WhatIfStoriesResponse>,
    WhatIfStoriesRequest
  >(data);

  return response.data;
};

export const getWhatIfStoryWithFile = async (dataBody: any): Promise<any> => {
  const data: IService<any> = {
    method: 'POST',
    relativePath: '/voice-file-to-text',
    data: dataBody,
  };

  const response = await request.requestService<AxiosResponse<any>, any>(data);
  console.log(response, 'ressss');

  return response.data;
};

export const submitWhatIfStory = async (
  dataBody: WhatIfStorySubmitRequest,
): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService<WhatIfStorySubmitRequest> = {
    method: 'POST',
    relativePath: '/whatif-send-text',
    headers: header,
    data: dataBody,
  };

  const response = await request.requestService<
    AxiosResponse<WhatIfStorySubmitResponse>,
    WhatIfStorySubmitRequest
  >(data);

  return response.data;
};

export type WhatIfStoryViewRequest = { story_id: number };

export const getWhatIfStoryView = async (
  dataBody: WhatIfStoryViewRequest,
): Promise<WhatIfStoryViewResponse[]> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };

  const data: IService<WhatIfStoryViewRequest> = {
    method: 'GET',
    relativePath: `get-whatif-story-view/${dataBody.story_id}`,
    headers: header,
  };

  const response = await request.requestService<
    AxiosResponse<WhatIfStoryViewResponse[]>,
    WhatIfStoryViewRequest
  >(data);

  return response.data;
};

export const getUserInfo = async () => {
  try {
    const response = await fetch('https://app.tadatoon.com/api/me', {
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error('Failed to fetch user info:', err);
    return null;
  }
};
